# frozen_string_literal: true

require_relative 'base'

module Engine
  module Action
    class PayoffDebt < Base
    end
  end
end
